import { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PublicLayout } from "@/layouts/PublicLayout";
import { Button } from "@/components/ui/button";
import { HeroSection } from "@/components/landing/HeroSection";
import { WhatFlytDoesSection } from "@/components/landing/WhatFlytDoesSection";
import { PricingSection } from "@/components/landing/PricingSection";
import { FamilyLifeSection } from "@/components/landing/FamilyLifeSection";
import { PrinciplesSection } from "@/components/landing/PrinciplesSection";
import { ScreenTimeSection } from "@/components/landing/ScreenTimeSection";
import { SafetySection } from "@/components/landing/SafetySection";
import { FinalCtaSection } from "@/components/landing/FinalCtaSection";

export default function Landing() {
  const heroRef = useRef<HTMLDivElement>(null);
  const finalCtaRef = useRef<HTMLDivElement>(null);
  const pricingRef = useRef<HTMLDivElement>(null);
  const [heroVisible, setHeroVisible] = useState(true);
  const [finalCtaVisible, setFinalCtaVisible] = useState(false);
  const [pricingVisible, setPricingVisible] = useState(false);

  useEffect(() => {
    const heroEl = heroRef.current;
    const finalEl = finalCtaRef.current;
    const pricingEl = pricingRef.current;
    if (!heroEl || !finalEl || !pricingEl) return;

    const heroObs = new IntersectionObserver(
      ([entry]) => setHeroVisible(entry.isIntersecting),
      { threshold: 0 }
    );
    const finalObs = new IntersectionObserver(
      ([entry]) => setFinalCtaVisible(entry.isIntersecting),
      { threshold: 0 }
    );
    const pricingObs = new IntersectionObserver(
      ([entry]) => setPricingVisible(entry.isIntersecting),
      { threshold: 0 }
    );

    heroObs.observe(heroEl);
    finalObs.observe(finalEl);
    pricingObs.observe(pricingEl);

    return () => {
      heroObs.disconnect();
      finalObs.disconnect();
      pricingObs.disconnect();
    };
  }, []);

  const showStickyCta = !heroVisible && !finalCtaVisible && !pricingVisible;

  return (
    <PublicLayout>
      <div className="mx-auto max-w-2xl px-4 py-12 space-y-24">
        <HeroSection ref={heroRef} />
        <WhatFlytDoesSection />
        <PricingSection ref={pricingRef} />
        <FamilyLifeSection />
        <PrinciplesSection />
        <ScreenTimeSection />
        <SafetySection />
        <FinalCtaSection ref={finalCtaRef} />
      </div>

      {showStickyCta && (
        <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/85 p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom,0px))] md:hidden">
          <Button className="w-full" size="lg" asChild>
            <Link to="/register">Kom i gang gratis</Link>
          </Button>
        </div>
      )}
    </PublicLayout>
  );
}
